let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3L0Vc")).then(() => parcelRequire('93zHH'));